<script lang="ts">
    import { onDestroy, onMount } from "svelte";
    import { link, page, route } from "@evento/application";
    import { logo, logoWhite } from "../assets/index.js";

    interface Props {
        homepage?: boolean;
    }

    let { homepage = false }: Props = $props();

    let element: HTMLElement | null = $state(null);
    let scrolled: boolean = $state(false);

    const observer = new IntersectionObserver(
        ([event]) => {
            scrolled = event.intersectionRatio < 1;
        },
        { threshold: [1] },
    );

    function isStickyScrolled(): boolean {
        if (!element) {
            return false;
        }

        const stickyTop = parseInt(window.getComputedStyle(element).top);
        const currentTop = element.getBoundingClientRect().top;

        return stickyTop === currentTop;
    }

    function getLogo(): string {
        if (import.meta.env.STORYBOOK) {
            return logo;
        }

        if (!scrolled && $page.component === "Homepage") {
            return logoWhite;
        }

        return logo;
    }

    onMount(function () {
        const observer = new IntersectionObserver(
            ([event]) => {
                scrolled = event.intersectionRatio < 1;
            },
            { threshold: [1] },
        );

        observer.observe(element);
    });

    onDestroy(function () {
        observer.unobserve(element);
    });
</script>


    <header
        bind:this={element}
        class="sticky -top-px right-0 left-0 z-20 flex h-32 items-center py-8 shadow-lg transition delay-50 ease-in-out landscape:relative lg:landscape:sticky"
        class:bg-header={!homepage || scrolled}
        class:bg-transparent={homepage && !scrolled}
    >
        <section class="container mx-auto flex px-4">
            <a href={route("front.homepage")} class={{ "bg-header-logo/40 p-8": homepage && !scrolled }} use:link>
                <h1>
                    {#key scrolled && (import.meta.env.STORYBOOK ? null : $page.component)}
                        <img class="h-12" src={getLogo()} alt="Nové otázky" />
                    {/key}
                </h1>
            </a>
        </section>
    </header>

